import React from 'react';
import { useListingForm } from '@/context/ListingFormContext';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Checkbox } from '@/components/ui/checkbox';
import { FormGroup, FormLabel, FormError } from '@/components/ui/form-components';
import AIDescriptionGenerator from './AIDescriptionGenerator';
import AITitleButton from './AITitleButton';
import { Phone } from 'lucide-react';

const ListingBasicInfo = () => {
  const { formData, errors, handleInputChange } = useListingForm();
  
  const handleDescriptionChange = (value: string) => {
    handleInputChange('description', value);
  };
  
  const handleGeneratedDescription = (description: string) => {
    handleInputChange('description', description);
  };
  
  const handleGeneratedTitle = (title: string) => {
    handleInputChange('title', title);
  };
  
  return (
    <div className="space-y-4 mb-8">
      <h2 className="text-lg font-semibold dark:text-white">Informacioni bazë</h2>
      
      <FormGroup>
        <FormLabel required>Titulli</FormLabel>
        <Input
          name="title"
          value={formData.title}
          onChange={(e) => handleInputChange('title', e.target.value)}
          placeholder="Titulli"
          maxLength={100}
          className={errors.title ? 'border-red-500' : ''}
        />
        {errors.title && <FormError>{errors.title}</FormError>}
        <AITitleButton
          description={formData.description}
          category={formData.category}
          subcategory={formData.subcategory}
          condition={formData.condition}
          onGeneratedTitle={handleGeneratedTitle}
        />
      </FormGroup>
      
      <FormGroup>
        <FormLabel required>Numri i telefonit</FormLabel>
        <div className="flex gap-2">
          <Select
            value={formData.phoneCountryCode || '+355'}
            onValueChange={(value) => handleInputChange('phoneCountryCode', value)}
          >
            <SelectTrigger className="w-32">
              <SelectValue placeholder="Kodi" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="+355">🇦🇱 +355</SelectItem>
              <SelectItem value="+383">🇽🇰 +383</SelectItem>
            </SelectContent>
          </Select>
          <div className="flex-1 relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <Phone className="h-4 w-4 text-gray-400" />
            </div>
            <Input
              name="phone"
              value={formData.phone}
              onChange={(e) => handleInputChange('phone', e.target.value)}
              placeholder="Numri i telefonit"
              className={`pl-10 ${errors.phone ? 'border-red-500' : ''}`}
              type="tel"
            />
          </div>
        </div>
        {errors.phone && <FormError>{errors.phone}</FormError>}
        
        {/* WhatsApp and Viber Checkboxes */}
        <div className="flex gap-4 mt-2">
          <div className="flex items-center space-x-2">
            <Checkbox
              id="whatsapp"
              checked={formData.whatsappEnabled || false}
              onCheckedChange={(checked) => handleInputChange('whatsappEnabled', checked)}
            />
            <label htmlFor="whatsapp" className="text-sm text-gray-700">WhatsApp</label>
          </div>
          <div className="flex items-center space-x-2">
            <Checkbox
              id="viber"
              checked={formData.viberEnabled || false}
              onCheckedChange={(checked) => handleInputChange('viberEnabled', checked)}
            />
            <label htmlFor="viber" className="text-sm text-gray-700">Viber</label>
          </div>
        </div>
      </FormGroup>
      
      <FormGroup>
        <FormLabel>Përshkrimi</FormLabel>
        <Textarea
          name="description"
          value={formData.description}
          onChange={(e) => handleDescriptionChange(e.target.value)}
          placeholder="Përshkrimi"
          className="resize-none h-32"
        />
        <AIDescriptionGenerator
          title={formData.title}
          category={formData.category}
          subcategory={formData.subcategory}
          condition={formData.condition}
          onGeneratedDescription={handleGeneratedDescription}
        />
      </FormGroup>
    </div>
  );
};

export default ListingBasicInfo;
